import _ from 'lodash';

import { LegacyReportConfigs } from 'scripts/domain/models/reports/report_configs';

export function getAllReportConfigs(context) {
  let reportConfigs = context.stores.reportConfigs.get().configs;

  return _.concat(LegacyReportConfigs, reportConfigs);
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/reporting/lib/reporting_helpers.js